// extracted by mini-css-extract-plugin
module.exports = {"container":"components_container__UOADy"};